import React, { useState, useEffect } from "react";
import PreAuthForm from "../components/apply/PreAuthForm";
import PasswordProtection from "../components/apply/PasswordProtection";
import LoanApplicationForm from "../components/apply/LoanApplicationForm";

const Apply = () => {
  const [step, setStep] = useState("preauth"); // 'preauth', 'verify', 'application'
  const [userData, setUserData] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if already authenticated
    const auth = localStorage.getItem("loanAppAuth");
    const authTime = localStorage.getItem("loanAppAuthTime");

    if (auth && authTime) {
      const timeElapsed = Date.now() - parseInt(authTime);
      // Token valid for 1 hour
      if (timeElapsed < 3600000) {
        setIsAuthenticated(true);
        setStep("application");
      } else {
        // Clear expired authentication
        localStorage.removeItem("loanAppAuth");
        localStorage.removeItem("loanAppAuthTime");
      }
    }
  }, []);

  const handleCodeSent = (data) => {
    setUserData(data);
    setStep("verify");
  };

  const handleAuthenticated = () => {
    setIsAuthenticated(true);
    setStep("application");
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserData(null);
    setStep("preauth");
    localStorage.removeItem("loanAppAuth");
    localStorage.removeItem("loanAppAuthTime");
  };

  // Render based on current step
  if (step === "preauth") {
    return <PreAuthForm onCodeSent={handleCodeSent} />;
  }

  if (step === "verify" && userData) {
    return (
      <PasswordProtection
        onAuthenticated={handleAuthenticated}
        userData={userData}
      />
    );
  }

  if (step === "application" && isAuthenticated) {
    return <LoanApplicationForm onLogout={handleLogout} />;
  }

  // Fallback to preauth if something goes wrong
  return <PreAuthForm onCodeSent={handleCodeSent} />;
};

export default Apply;
